import { createFileRoute } from "@tanstack/react-router";
import { IndexView } from "../views/docs/index/index-view";

export const Route = createFileRoute("/_docs")({
  component: IndexView,
});
